import { object, string, boolean, optional } from 'superstruct';

export const exampleModuleConfigSchema = object({
  someRequiredProperty: string(),
  someOptionalFeatureFlag: optional(boolean()),
});
